import PropTypes from 'prop-types';
import { truncate } from 'lodash';
import cn from "../../../../utils/cn";
import { jsx as _jsx } from "react/jsx-runtime";
const EmailAddress = _ref => {
  let {
    className,
    disableLink,
    emailAddress
  } = _ref;
  const email = emailAddress.email_address ? emailAddress.email_address : emailAddress;
  const wrapperClass = cn('text-sm', {
    'text-brand-blue': disableLink,
    'text-action-blue': !disableLink
  }, className);
  return /*#__PURE__*/_jsx("span", {
    className: wrapperClass,
    children: disableLink ? email : /*#__PURE__*/_jsx("a", {
      href: `mailto:${email}`,
      title: email,
      children: truncate(email, {
        length: 40
      })
    })
  });
};
EmailAddress.propTypes = {
  /** className */
  className: PropTypes.string,
  /** true to disable the mailto link */
  disableLink: PropTypes.bool,
  /** email address string or object */
  emailAddress: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
};
export default EmailAddress;
//# sourceMappingURL=EmailAddress.js.map